import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { sendPageView } from "./utils/analytics";

export function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    sendPageView(path, document.title);
  }, [location]);

  return null;
}